import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print, checkPermission, SocketEvents } from 'utils';
import {
  Table,
  Pagination,
  Tooltip,
  Input,
  DatePicker,
  Select,
  Modal,
  PaperClip,
  User,
  Render,
  Countdown,
  ModalPayment,
  FileUploadPlaceholder,
} from 'components';
import { ChatService, GeneralService, NotificationService } from 'services';
import { SendIcon, AddIcon, PaperclipIcon, Document2Icon, BackIcon, ImageIcon } from 'assets/icons';
import moment from 'moment';
import { UserImage, WhiteImage, Alert, Logo } from 'assets/img';
import * as Jetemit from 'jetemit';
import ModalCreate from './modal-create';
import ModalFiles from 'screens/client/chat/modal-view-files';
import qs from 'query-string';
import { Chat } from 'types';
import { StorageService } from 'services';

interface Props extends RootState, RouteComponentProps {
  dispatch: any;
}

const INITIAL_STATE = {};

class ChatScreen extends React.Component<Props> {
  messagesEnd: any = null;
  notificationsEnd: any = null;
  textareaRef: any = null;
  timer: any = undefined;

  state = {
    messages: [],
    form: {
      search: '',
      message: '',
    },
    textareaHeight: 55.8,
    unsubscriber: () => {},
    unsubscriber2: () => {},
    page: 1,
    last_page: 1,
    chat: null as Chat | null,
    visible: false,
    data: [],
    currentUser: null,
    visible_files: false,
    item: null,
    time: 0,
    visible_consumed: false,
    visible_payment: false,
    price: 0,
    membership_status: Constants.ACCES_STATUS.ACCESS_DENIED,
    plan_user: null,
    sending_file: false,
    sending_file_placeholder: false,
    uploading_is_image: false,
    notifications: [] as any[],
    notifications_page: 1,
    notifications_pages: 1,
    notifications_loading: false,
    notifications_loaded: false,
    unread_notifications_count: 0,
    viewing_notifications: false,
  };

  componentDidMount() {
    this.props.dispatch({
      type: 'SET_HEADER',
      payload: {
        title: 'Chat',
        onBack: null,
      },
    });

    this.props.dispatch({
      type: 'SET_SUBHEADER',
      payload: {
        title: '',
      },
    });

    const params = qs.parse(this.props.location.search);
    if (params.chat_id) {
      this.loadMessages(Number(params.chat_id));
    }

    /**
     * Cuando se viene desde "Comunidad de abogados" ya no se crea el chat de
     * inmediato; sino después de enviar el primer mensaje.
     */
    const pendingLawyer = this.props.pending_lawyer;
    if (pendingLawyer && !params.chat_id) {
      this.setState({
        chat: {
          id: null,
          type: Constants.CHAT_TYPE.LAWYER_COMMUNITY,
          status: Constants.CHAT_STATUS.ACTIVE,
        } as any,
        currentUser: pendingLawyer,
        messages: [],
      });

      this.props.dispatch({
        type: 'SET_PENDING_LAWYER',
        payload: null,
      });
    }

    this.setState({
      unsubscriber2: Jetemit.on('open-create-chat', () => {
        this.create();
      }),
      unsubscriber: Jetemit.on(SocketEvents.CHATS.MESSAGE, (data: any) => {
        if (data.message.chat_id == this.state.chat?.id) {
          if (data.status == Constants.CHAT_RESOLVED_STATUS.RESOLVED) {
            this.load(true);
            this.loadMessages(data.message.chat_id);
            return;
          }

          let messages: any = [...this.state.messages];
          messages.push(data.message);
          this.setState(
            {
              messages,
              chat: data.chat,
              currentUser:
                this.props.user?.id === data?.chat?.sender_id
                  ? data?.chat?.receiver
                  : data?.chat?.sender,
            },
            () => {
              this.scrollToBottom();
            },
          );
        }

        if (
          data.chat?.sender_id == this.props.user?.id ||
          data?.chat?.receiver_id == this.props.user?.id
        ) {
          this.setState((prevState: any) => {
            const existingChats = [...prevState.data];
            const chatIndex = existingChats.findIndex((c) => c.id === data.chat.id);

            if (chatIndex !== -1) {
              existingChats.splice(chatIndex, 1);
            }
            existingChats.unshift(data.chat);
            return {
              data: existingChats,
            };
          });

          // Cuando un abogado acepta (o el admin asigna) el chat, se recarga la
          // lista desde el servidor para no depender solo del payload del socket.
          if (data.event === SocketEvents.CHATS.ACCEPTED) {
            this.load(true);
          }
        }
      }),
    });

    this.load();
    this.getSelects();
    this.loadUnreadNotificationsCount();

    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  }

  getSelects = async () => {
    const selects: any = await GeneralService.getSelects({
      user_id: this.props.user?.id,
      services: true,
      service_id: Constants.SERVICES.CHAT,
    });

    this.setState({
      price: selects.services[0].price,
    });
  };

  componentWillUnmount() {
    this.state.unsubscriber();
    window.removeEventListener('resize', this.handleResize);

    this.state.unsubscriber2();
    this.state.unsubscriber();
  }

  handleResize = () => {
    const header = document.getElementById('header');
    const containerRouter = document.querySelector(
      '.container-padding-router',
    ) as HTMLElement | null;
    const containerRouter2 = document.querySelector('.container-router') as HTMLElement | null;
    if (!header) return;

    if (window.innerWidth < 768 && (this.state.chat || this.state.viewing_notifications)) {
      header.style.display = 'none';
      if (containerRouter) {
        containerRouter.style.paddingTop = '0px';
      }
      if (containerRouter2) {
        containerRouter2.style.paddingTop = '0px';
      }
    } else {
      header.style.display = '';
      if (containerRouter) {
        containerRouter.style.paddingTop = '40px';
      }
      if (containerRouter2) {
        containerRouter2.style.paddingTop = '50px';
      }
    }
  };

  load = async (withoutLoading = false, callback = () => {}) => {
    const res: any = await ChatService.get({
      withoutLoading,
      page: this.state.page,
      ...this.state.form,
      user_id: this.props.user?.id,
      per_page: 10,
    });
    this.setState(
      {
        data: res.chats.rows,
        last_page: res.chats.count,
        membership_status: res.access_status,
        plan_user: res.plan_user,
      },
      () => callback(),
    );
  };

  loadMessages = async (chat_id: number, _user?: any) => {
    if (!chat_id) return;
    const res: any = await ChatService.view({
      user_id: this.props.user?.id,
      chat_id,
    });

    const user = this.props.user.id === res.chat?.sender_id ? res.chat?.receiver : res.chat?.sender;

    this.setState(
      (prev: any) => ({
        chat: res.chat,
        messages: res.messages || [],
        time: res.time,
        currentUser: user,
        viewing_notifications: false,
        data: prev.data.map((i: any) => {
          if (i.id == chat_id) {
            return {
              ...i,
              unread_sender: this.props.user?.id === i.sender_id ? 0 : i.unread_sender,
              unread_receiver: this.props.user?.id === i.receiver_id ? 0 : i.unread_receiver,
            };
          }
          return i;
        }),
      }),
      () => {
        this.scrollToBottom();
        this.handleResize();
      },
    );
  };

  scrollToBottom = () => {
    this.messagesEnd.scrollTo({
      behavior: 'smooth',
      top: this.messagesEnd.scrollHeight,
    });
  };

  autoGrow = (e: any) => {
    if (e.nativeEvent.keyCode == 13) {
      e.preventDefault();
      this.send();
    }
    this.textareaRef.style.height = 'inherit';
    this.textareaRef.style.height = `${Math.max(this.textareaRef.scrollHeight, 55.8)}px`;
  };

  send = async (file = '') => {
    if (this.state.form.message || file != '') {
      const message = this.state.form.message;
      this.setState({
        form: {
          ...this.state.form,
          message: '',
        },
        height: 0,
      });

      const isPendingChat = !this.state.chat?.id;

      if (isPendingChat) {
        const pendingLawyer: any = this.state.currentUser;
        const res: any = await ChatService.save({
          sender_id: this.props.user?.id,
          receiver_id: pendingLawyer?.id,
          type: Constants.CHAT_TYPE.LAWYER_COMMUNITY,
          without_membership: true,
          message,
        });

        const newChatId = res?.chat?.id;

        this.props.history.replace(`/lawyer/chat?chat_id=${newChatId}`);

        this.load(true);
        if (newChatId) {
          this.loadMessages(newChatId);
        }

        this.setState({ sending_file: false, sending_file_placeholder: false });
        return;
      }

      await ChatService.send({
        chat_id: this.state.chat?.id,
        message,
        user_id: this.props.user?.id,
        withoutLoading: true,
        hasFile: true,
        file,
      });
      this.setState({ sending_file: false, sending_file_placeholder: false });
    }
  };

  change = (e: any) => {
    this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: e.target.value,
      },
    });
  };

  create = () => {
    const { membership_status } = this.state;
    if (membership_status === Constants.ACCES_STATUS.ACCESS_LIMITED) {
      return this.setState({ visible_consumed: true });
    }
    if (membership_status === Constants.ACCES_STATUS.ACCESS_GRANTED) {
      return this.setState({ visible: true });
    }
  };

  onClose = (chat_id: number | null = null, reload: boolean = false) => {
    this.setState(
      {
        visible: false,
        visible_consumed: false,
        visible_payment: false,
      },
      () => {
        if (chat_id) {
          this.load(true);
          this.loadMessages(chat_id);
        }
      },
    );
  };

  updateChat = async () => {
    try {
      await ChatService.update({
        chat_id: this.state.chat?.id,
        withoutLoading: false,
      });
      this.setState((prev: any) => ({
        ...prev,
        chat: {
          ...prev.chat,
          status: Constants.CHAT_STATUS.INACTIVE,
        },
      }));
    } catch (error) {}
  };

  openViewFiles = (e: any, item: any) => {
    e.preventDefault();
    this.setState(
      {
        visible_files: true,
        item,
      },
      () => {
        Globals.hideTooltip();
      },
    );
  };

  onCloseViewFiles = () => {
    this.setState({
      visible_files: false,
      item: null,
    });
  };

  resolvedCallChat = async (status: number) => {
    let status_text = '';

    switch (status) {
      case Constants.CHAT_RESOLVED_STATUS.RESOLVED:
        status_text = 'Resuelto';
        break;
      case Constants.CHAT_RESOLVED_STATUS.NO_RESOLVED:
        status_text = 'Sin resolver';
        break;
      case Constants.CHAT_RESOLVED_STATUS.REVIEW:
        status_text = 'En revisión';
        break;
      case Constants.CHAT_RESOLVED_STATUS.IN_PROCESS:
        status_text = 'En proceso';
        break;
      case Constants.CHAT_RESOLVED_STATUS.PENDING:
        status_text = 'Pendiente';
        break;
    }

    Globals.confirm('¿Desea cambiar el estado de la llamada a ' + status_text + '?', async () => {
      try {
        await ChatService.resolvedChatCall({
          chat_id: this.state.chat?.id,
          resolved_by: (this.state.currentUser as any)?.id,
          status,
        });
        Globals.showSuccess('Caso actualizado correctamente');
        if (status == Constants.CHAT_RESOLVED_STATUS.REVIEW) {
          this.props.history.replace('/lawyer/chat');
          setTimeout(() => {
            Jetemit.emit('open-create-chat');
          }, 500);
        } else {
          this.load();
          this.loadMessages(this.state.chat?.id as number);
        }
      } catch (error) {}
    });
  };

  resolvedChat = async (status: number) => {
    let status_text = '';

    switch (status) {
      case Constants.CHAT_RESOLVED_STATUS.RESOLVED:
        status_text = 'Resuelto';
        break;
      case Constants.CHAT_RESOLVED_STATUS.NO_RESOLVED:
        status_text = 'Sin resolver';
        break;
      case Constants.CHAT_RESOLVED_STATUS.REVIEW:
        status_text = 'En revisión';
        break;
      case Constants.CHAT_RESOLVED_STATUS.IN_PROCESS:
        status_text = 'En proceso';
        break;
      case Constants.CHAT_RESOLVED_STATUS.PENDING:
        status_text = 'Pendiente';
        break;
    }

    Globals.confirm('¿Desea marcar el chat como ' + status_text + '?', async () => {
      try {
        await ChatService.resolvedChat({
          chat_id: this.state.chat?.id,
          resolved_by: (this.state.currentUser as any)?.id,
          status: status,
        });
        Globals.showSuccess('Chat actualizado correctamente');
        if (status == Constants.CHAT_RESOLVED_STATUS.REVIEW) {
          this.props.history.replace('/lawyer/chat');
          setTimeout(() => {
            Jetemit.emit('open-create-chat');
          }, 500);
        } else {
          this.load();
          this.loadMessages(this.state.chat?.id as number);
        }
      } catch (error) {}
    });
  };

  back = () => {
    this.setState(
      {
        chat: null,
        viewing_notifications: false,
      },
      () => this.handleResize(),
    );
  };

  loadUnreadNotificationsCount = async () => {
    const res: any = await NotificationService.client.unreadCount({
      withoutLoading: true,
      withoutError: true,
    });
    this.setState({ unread_notifications_count: res?.count || 0 });
  };

  loadNotifications = async (page = 1) => {
    this.setState({ notifications_loading: true });
    const res: any = await NotificationService.client.get({
      page,
      per_page: 10,
      withoutLoading: page !== 1,
    });
    const rows = res?.notifications?.rows || [];
    this.setState(
      (prev: any) => ({
        notifications: page === 1 ? rows : [...prev.notifications, ...rows],
        notifications_page: page,
        notifications_pages: res?.notifications?.count || 1,
        notifications_loaded: true,
        notifications_loading: false,
      }),
      () => {
        this.markNotificationsRead(rows);
        if (page === 1) this.scrollNotificationsToBottom();
      },
    );
  };

  loadMoreNotifications = () => {
    if (this.state.notifications_page >= this.state.notifications_pages) return;
    this.loadNotifications(this.state.notifications_page + 1);
  };

  markNotificationsRead = async (rows: any[]) => {
    const unread = rows.filter((r: any) => !r.read_at);
    if (unread.length === 0) return;
    await Promise.all(
      unread.map((r: any) =>
        NotificationService.client.read({ id: r.id, withoutLoading: true, withoutError: true }),
      ),
    );
    this.loadUnreadNotificationsCount();
  };

  scrollNotificationsToBottom = () => {
    if (this.notificationsEnd) {
      this.notificationsEnd.scrollTo({
        behavior: 'smooth',
        top: this.notificationsEnd.scrollHeight,
      });
    }
  };

  openNotificationImage = (url: string) => {
    window.open(url, '_blank');
  };

  openNotifications = () => {
    this.setState({ chat: null, viewing_notifications: true }, () => {
      this.handleResize();
      if (!this.state.notifications_loaded) {
        this.loadNotifications(1);
      } else {
        this.markNotificationsRead(this.state.notifications);
        this.scrollNotificationsToBottom();
      }
    });
  };

  statusColor = (status: number) => {
    switch (status) {
      case Constants.CHAT_RESOLVED_STATUS.PENDING:
        return Colors.orange;
      case Constants.CHAT_RESOLVED_STATUS.RESOLVED:
        return Colors.green;
      case Constants.CHAT_RESOLVED_STATUS.NO_RESOLVED:
        return Colors.danger;
      case Constants.CHAT_RESOLVED_STATUS.REVIEW:
        return Colors.yellow;
      case Constants.CHAT_RESOLVED_STATUS.IN_PROCESS:
        return Colors.cyan2;
    }
  };

  openModalPayment = () => {
    this.setState({
      visible_payment: true,
      visible_consumed: false,
    });
  };

  private openFacturaPdf = (relPathIn?: string) => {
    if (!relPathIn) return;

    const base = (Constants.BASE_PUBLIC || '').replace(/\/+$/, '');
    const rel = relPathIn.startsWith('/') ? relPathIn : `/${relPathIn}`;
    const url = `${base}${rel}`;

    if ((window as any).webkit?.messageHandlers?.cordova_iab) {
      const payload = { message: 'open_url', url };
      (window as any).webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify(payload));
      return;
    }

    Print(url, true);
  };

  onSuccesPayment = async (data: any) => {
    try {
      const { user } = this.props;
      const res: any = await GeneralService.savePayment({
        user_id: user?.id,
        service_id: Constants.SERVICES.CHAT,
        ...data,
      });

      const relPathObjOrStr = res?.facturaPDF?.pdf?.relPath;
      const relPath =
        typeof relPathObjOrStr === 'string' ? relPathObjOrStr : relPathObjOrStr?.relPath;

      this.openFacturaPdf(relPath);

      this.onClose(this.state.chat?.id ?? null, true);
      Globals.showSuccess('Se ha enviado el pago correctamente, ya puede crear un nuevo chat');
    } catch (error) {
      console.error(error);
      Globals.showError('No se pudo registrar el pago');
    }
  };

  render() {
    const {
      messages,
      visible,
      currentUser,
      visible_files,
      visible_consumed,
      visible_payment,
      membership_status,
      viewing_notifications,
      notifications,
      unread_notifications_count,
    } = this.state;
    const chat: Chat | null = this.state.chat;
    const isInternal = this.props.user?.internal === Constants.LAWYER_INTERNAL.YES;
    const isClient = this.props.user?.level_id == Constants.LEVELS.CLIENT;
    const showCallResolvedStatus =
      isInternal &&
      chat?.status == Constants.CHAT_STATUS.ACTIVE &&
      chat?.type === Constants.CHAT_TYPE.LAWYER_LAWYER;
    const showChatResolvedStatus =
      isInternal &&
      chat?.status == Constants.CHAT_STATUS.ACTIVE &&
      chat?.type === Constants.CHAT_TYPE.CLIENT_LAWYER;

    return (
      <div id='client-chat'>
        <div className={`container-modal-right ${visible_files ? 'active' : ''}`}>
          {visible_files && (
            <ModalFiles item={this.state.item} onClose={() => this.onCloseViewFiles()} />
          )}
        </div>
        <Modal
          className='modal-create-chat'
          visible={visible}
          title='Nuevo mensaje'
          onClose={() => this.onClose()}
        >
          {/*
              // @ts-ignore */}
          <ModalCreate onClose={(chat_id: number | null = null) => this.onClose(chat_id)} />
        </Modal>

        <Modal
          id='modal-consumed-payment'
          visible={visible_consumed}
          title='Chats'
          onClose={() => this.onClose()}
        >
          <img src={Alert} />
          <p className='title'>Usted ha consumido sus usos de chat</p>
          <p>Puede obtener el servicio mediante pago o esperar el próximo mes</p>
          <div className='btn-container'>
            <button className='btn btn-accept' onClick={this.openModalPayment}>
              Pagar
            </button>
          </div>
        </Modal>

        <Modal
          className='modal-create-chat'
          visible={visible_payment}
          title=''
          onClose={() => this.onClose()}
        >
          {/*// @ts-ignore */}
          <ModalPayment
            onClose={(reload: boolean) => this.onClose()}
            price={this.state.price}
            onSuccess={(data: any) => this.onSuccesPayment(data)}
            title='Chats'
          />
        </Modal>

        <div className='row mr-0'>
          <div className='col-md-4 pr-0'>
            <div
              className={`container-list d-md-block ${this.state.chat == null && !viewing_notifications ? 'd-block' : 'd-none'}`}
            >
              <div className='header-chat'>
                <Input
                  value={this.state.form.search}
                  name='search'
                  placeholder='Buscar'
                  className='input-table'
                  onSubmit={() => this.load()}
                  searchRight={true}
                  onChange={(e: any) => {
                    clearTimeout(this.timer);
                    this.timer = setTimeout(() => {
                      this.load(true);
                    }, 1000);
                    this.change(e);
                  }}
                />
                <Render
                  condition={
                    isInternal &&
                    this.state.plan_user !== null &&
                    membership_status !== Constants.ACCES_STATUS.ACCESS_DENIED
                  }
                >
                  <button className='btn btn-add' onClick={() => this.create()}>
                    <img src={AddIcon} />
                  </button>
                </Render>
              </div>
              <div className='list'>
                <div
                  className={`item-chat ${viewing_notifications ? 'active' : ''}`}
                  onClick={() => this.openNotifications()}
                >
                  <img src={Logo} />
                  <div style={{ flex: 1 }}>
                    <div className='container-right'>
                      <Render condition={unread_notifications_count > 0}>
                        <div className='unread'>
                          <span>{unread_notifications_count}</span>
                        </div>
                      </Render>
                    </div>
                    <p className='user-chat'>Legalmente</p>
                    <div className='container-flex'>
                      <small className='find-lawyer'>Comunicados</small>
                    </div>
                  </div>
                </div>
                {this.state.data.map((item: any) => {
                  const user =
                    this.props.user?.id === item?.sender_id ? item?.receiver : item?.sender;
                  const unread =
                    this.props.user?.id === item?.sender_id
                      ? item?.unread_sender
                      : item?.unread_receiver;
                  const resolved_status = item?.chatResolved;

                  if (item?.chat_id) return;

                  return (
                    <div
                      className={`item-chat ${item.id == this.state.chat?.id ? 'active' : ''}`}
                      onClick={() => this.loadMessages(item?.id, user)}
                    >
                      <img src={user?.photo ? Constants.BASE_STORAGE + user?.photo : WhiteImage} />
                      <div style={{ flex: 1 }}>
                        <div className='container-right'>
                          <Render condition={item?.type === Constants.CHAT_TYPE.CLIENT_LAWYER}>
                            <div
                              className='status-container'
                              style={{
                                backgroundColor: this.statusColor(resolved_status?.status),
                              }}
                            >
                              <span>{resolved_status?.status_text}</span>
                            </div>
                          </Render>
                          <Render condition={unread > 0}>
                            <div className='unread'>
                              <span>{unread}</span>
                            </div>
                          </Render>
                        </div>
                        <p className='user-chat'>
                          {user?.name || ''} {user?.lastname || ''}
                        </p>
                        <p className='last-message'>
                          {item.last_message?.file ? 'Archivo Adjunto' : item.last_message?.message}
                        </p>
                        <div className='container-flex'>
                          <Render
                            condition={item?.type === Constants.CHAT_TYPE.CLIENT_LAWYER_WITH_FILES}
                          >
                            <small className='find-lawyer'>Ubica tu abogado</small>
                          </Render>
                          <Render condition={item?.type === Constants.CHAT_TYPE.LAWYER_COMMUNITY}>
                            <small className='find-lawyer'>Comunidad de abogados</small>
                          </Render>
                          <Render condition={item?.type === Constants.CHAT_TYPE.CLIENT_LAWYER}>
                            <small className='find-lawyer'>Consulta interna</small>
                          </Render>
                          <p className='date'>
                            {moment(item.updated_at || item.created_at).format('DD/MM/YYYY HH:mm')}
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}

                {this.state.data.length == 0 && (
                  <p className='no-chat'>No se han encontrado chats disponibles</p>
                )}

                <Pagination
                  pages={this.state.last_page}
                  active={this.state.page}
                  onChange={async (page: number) => {
                    await this.setState({
                      page: page,
                    });
                    this.load();
                  }}
                />
              </div>
            </div>
          </div>
          <div className='col-md-8 px-0 chat-messages-container'>
            {viewing_notifications ? (
              <>
                <div className='container-messages-header px-5'>
                  <div className='container-user'>
                    <button className='btn btn-back d-block d-md-none' onClick={() => this.back()}>
                      <img src={BackIcon} />
                    </button>
                    <div id='container-user'>
                      <img src={Logo} className='image' />
                      <div className='container-name'>
                        <p className='name'>Legalmente</p>
                        <p className='description'>Comunicados</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className='container-messages height'
                  ref={(el) => {
                    this.notificationsEnd = el;
                  }}
                >
                  {this.state.notifications_page < this.state.notifications_pages && (
                    <button
                      type='button'
                      className='btn-load-older'
                      disabled={this.state.notifications_loading}
                      onClick={this.loadMoreNotifications}
                    >
                      Ver comunicados anteriores
                    </button>
                  )}
                  {[...notifications].reverse().map((item: any) => (
                    <div className='item-message notification' key={item.id}>
                      <p className='sender'>Legalmente</p>
                      <p className='notification-title'>{item.title}</p>
                      <p className='notification-subject'>{item.subject}</p>
                      <p className='message'>{item.description}</p>
                      {(item.images || []).map((image: any) => (
                        <a
                          href='#'
                          key={image.position}
                          className='notification-file'
                          onClick={(e: any) => {
                            e.preventDefault();
                            this.openNotificationImage(image.url);
                          }}
                        >
                          <img src={ImageIcon} />
                          <p>Imagen adjunta</p>
                        </a>
                      ))}
                      <p className='date'>{moment(item.created_at).format('DD/MM/YYYY HH:mm')}</p>
                    </div>
                  ))}
                  {this.state.notifications_loaded && notifications.length === 0 && (
                    <p className='no-chat'>No posee comunicados</p>
                  )}
                </div>
              </>
            ) : chat != null ? (
              <>
                <div className='container-messages-header px-5'>
                  {currentUser !== null ? (
                    <>
                      <div className='container-user'>
                        <button
                          className='btn btn-back d-block d-md-none'
                          onClick={() => this.back()}
                        >
                          <img src={BackIcon} />
                        </button>
                        <User
                          image={(currentUser as any)?.photo}
                          name={
                            (currentUser as any)?.name || (currentUser as any)?.lastname
                              ? `${(currentUser as any)?.name || ''}  ${(currentUser as any)?.lastname || ''}`
                              : (currentUser as any)?.full_name || ''
                          }
                          description={
                            this.state.chat?.type == Constants.CHAT_TYPE.CLIENT_LAWYER_WITH_FILES
                              ? 'Ubica tu abogado'
                              : ''
                          }
                        />
                      </div>
                    </>
                  ) : (
                    <p className='no-chat'>Esperando abogado externo</p>
                  )}

                  <div className='container-flex'>
                    <Render
                      condition={
                        chat?.type === Constants.CHAT_TYPE.CLIENT_LAWYER_WITH_FILES && !!chat?.id
                      }
                    >
                      <div className='view-files'>
                        <Tooltip title='Ver archivos'>
                          <a
                            className='link-icon'
                            href='#'
                            onClick={(e: any) => this.openViewFiles(e, this.state.chat)}
                          >
                            <img src={PaperclipIcon} />
                          </a>
                        </Tooltip>
                      </div>
                    </Render>
                    <Render condition={showChatResolvedStatus}>
                      <div className='container-messages-btn'>
                        <button
                          className='btn btn-resolved'
                          onClick={() => this.resolvedChat(Constants.CHAT_RESOLVED_STATUS.RESOLVED)}
                        >
                          Resuelto
                        </button>
                        <Render condition={chat?.type === Constants.CHAT_TYPE.CLIENT_LAWYER}>
                          <button
                            className='btn btn-resolved'
                            style={{ backgroundColor: Colors.danger }}
                            onClick={() =>
                              this.resolvedChat(Constants.CHAT_RESOLVED_STATUS.NO_RESOLVED)
                            }
                          >
                            No resuelto
                          </button>
                        </Render>
                        <Render
                          condition={
                            chat?.type === Constants.CHAT_TYPE.CLIENT_LAWYER &&
                            ((chat as any)?.chatResolved?.status ==
                              Constants.CHAT_RESOLVED_STATUS.PENDING ||
                              (chat as any)?.chatResolved?.status ==
                                Constants.CHAT_RESOLVED_STATUS.IN_PROCESS)
                          }
                        >
                          <button
                            className='btn btn-yellow'
                            style={{ backgroundColor: Colors.yellow }}
                            onClick={() => this.resolvedChat(Constants.CHAT_RESOLVED_STATUS.REVIEW)}
                          >
                            En revisión
                          </button>
                        </Render>
                      </div>
                    </Render>
                    <Render condition={showCallResolvedStatus && currentUser != null}>
                      <div className='container-messages-btn'>
                        <button
                          className='btn btn-reject'
                          onClick={() =>
                            this.resolvedCallChat(Constants.CHAT_RESOLVED_STATUS.NO_RESOLVED)
                          }
                        >
                          Sin resolver
                        </button>
                        <button
                          className='btn btn-resolved'
                          onClick={() =>
                            this.resolvedCallChat(Constants.CHAT_RESOLVED_STATUS.RESOLVED)
                          }
                        >
                          Resuelto
                        </button>
                        <Render
                          condition={
                            chat?.type === Constants.CHAT_TYPE.CLIENT_LAWYER &&
                            ((chat as any)?.chatResolved?.status ==
                              Constants.CHAT_RESOLVED_STATUS.PENDING ||
                              (chat as any)?.chatResolved?.status ==
                                Constants.CHAT_RESOLVED_STATUS.IN_PROCESS)
                          }
                        >
                          <button
                            className='btn btn-yellow'
                            onClick={() =>
                              this.resolvedCallChat(Constants.CHAT_RESOLVED_STATUS.REVIEW)
                            }
                          >
                            En revisión
                          </button>
                        </Render>
                      </div>
                    </Render>
                    <Render
                      condition={
                        chat?.status === Constants.CHAT_STATUS.INACTIVE &&
                        chat?.type === Constants.CHAT_TYPE.CLIENT_LAWYER
                      }
                    >
                      <div
                        className='status-container'
                        style={{
                          backgroundColor: this.statusColor((chat as any)?.chatResolved?.status),
                        }}
                      >
                        <span>{(chat as any)?.chatResolved?.status_text}</span>
                      </div>
                    </Render>
                  </div>
                </div>

                <div
                  className='container-messages height'
                  ref={(el) => {
                    this.messagesEnd = el;
                  }}
                >
                  {messages.map((item: any) => {
                    if (!item.file && !item.message) return;

                    if (item.file) {
                      const ext = item.file.split('.').pop()?.toLowerCase();
                      const IMAGE_EXTS = [
                        'png',
                        'jpg',
                        'jpeg',
                        'gif',
                        'webp',
                        'bmp',
                        'tiff',
                        'tif',
                        'avif',
                        'heic',
                        'heif',
                      ];
                      const fileLabel = IMAGE_EXTS.includes(ext) ? 'Imagen' : ext?.toUpperCase();
                      return (
                        <a
                          href='#'
                          onClick={(e: any) => {
                            e.preventDefault();
                            StorageService.openFile(item.file);
                          }}
                          className={`link-file ${item.user_id == this.props.user?.id ? 'self' : ''}`}
                        >
                          <img src={IMAGE_EXTS.includes(ext) ? ImageIcon : Document2Icon} />
                          <p>
                            Archivo Adjunto <span>({fileLabel})</span>
                          </p>
                          <p className='date'>
                            {moment(item.created_at).format('DD/MM/YYYY HH:mm')}
                          </p>
                        </a>
                      );
                    } else {
                      return (
                        <div
                          className={`item-message ${item.user_id == this.props.user?.id ? 'self' : ''}`}
                        >
                          <p className='message'>{item.message}</p>
                          <p className='date'>
                            {moment(item.created_at).format('DD/MM/YYYY HH:mm')}
                          </p>
                        </div>
                      );
                    }
                  })}
                  {this.state.sending_file_placeholder && (
                    <FileUploadPlaceholder isImage={this.state.uploading_is_image} />
                  )}
                </div>
                <div style={{ padding: '20px' }}>
                  <div className='container-textarea'>
                    <div className='container-white'>
                      <textarea
                        className='form-control'
                        ref={(ref) => (this.textareaRef = ref)}
                        rows={1}
                        disabled={this.state.chat?.status === Constants.CHAT_STATUS.INACTIVE}
                        value={this.state.form.message}
                        placeholder='Escribir'
                        name='message'
                        style={{ minHeight: 38, resize: 'none' }}
                        onKeyDown={(e: any) => this.autoGrow(e)}
                        onChange={this.change}
                      />
                      <Render
                        condition={
                          this.state.chat?.status === Constants.CHAT_STATUS.ACTIVE &&
                          !!this.state.chat?.id
                        }
                      >
                        <PaperClip
                          formats={[
                            'pdf',
                            'doc',
                            'docx',
                            'xls',
                            'xlsx',
                            'ppt',
                            'pptx',
                            'png',
                            'jpg',
                            'jpeg',
                            'heic',
                            'heif',
                            'webp',
                            'bmp',
                            'tiff',
                            'tif',
                            'avif',
                          ]}
                          successText='Subir documento'
                          pendingText='Subir documento'
                          value={''}
                          onChange={(e: any) => {
                            this.setState(
                              {
                                sending_file: true,
                                sending_file_placeholder: true,
                                uploading_is_image: e.target.value?.type === 'image/png',
                              },
                              () => this.scrollToBottom(),
                            );
                            this.send(e.target.value);
                          }}
                        />
                      </Render>
                    </div>
                    <Render condition={this.state.chat?.status === Constants.CHAT_STATUS.ACTIVE}>
                      <div>
                        <button
                          className={`btn${this.state.sending_file ? ' btn-sending' : ''}`}
                          onClick={() => this.send()}
                          disabled={this.state.sending_file}
                        >
                          <img src={SendIcon} className='send-icon' />
                        </button>
                      </div>
                    </Render>
                  </div>
                </div>
              </>
            ) : (
              <p className='no-items'>
                Seleccione un chat a la izquierda{' '}
                {this.props.user?.level_id == Constants.LEVELS.CLIENT ? 'o cree uno nuevo' : ''}
              </p>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
    pending_lawyer: state.pending_lawyer,
  };
})(ChatScreen);
